<template>
  <div>
    <condition-part
      :hasDate="false"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasWarehouse="true"
      :hasFoodMajorKind="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasFoodSupplier="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @printPdf="printPdf"
      @downloadPdf="downloadPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      columns: [
        { name: "WarehouseNumber" },
        { name: "WarehouseName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Qty" },
        { name: "SafeQty" },
        { name: "LackQty" },
        { name: "Unit" },
        { name: "SupplierNumber" },
        { name: "SupplierName" },
      ],
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    setWarehouses(items) {
      this.warehouseIds = items;
    },
    setFoodKinds(items) {
      this.foodKindIds = items;
    },
    downloadExcel(condition) {
      this.$api.reportExcels.getSafeQty(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSafeQty(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSafeQty(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getSafeQty(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
